function d(i, c, e) {
  const { opacity: t, zIndex: n } = c;
  t != null && t !== e.opacity && i.setOpacity(t), n != null && n !== e.zIndex && i.setZIndex(n);
}
export {
  d as updateGridLayer
};
